import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import config from '../config/config';

class LogoutPage extends React.Component {
  render() {
    reactLocalStorage.clear();
    window.location.href = config.auth;
    return null;
  }
}
export default LogoutPage;